import React from 'react';
import Svg, { Path } from 'react-native-svg';
var SVGComponent = function SVGComponent(props) {
  var style = props.style;
  return /*#__PURE__*/React.createElement(Svg, {
    style: style,
    width: "25",
    height: "25",
    viewBox: "0 0 25 25",
    fill: "none"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 17.5C10.0147 17.5 8 15.4853 8 13C8 10.5147 10.0147 8.5 12.5 8.5C14.9853 8.5 17 10.5147 17 13C17 15.4853 14.9853 17.5 12.5 17.5ZM12.5 16C10.8431 16 9.5 14.6569 9.5 13C9.5 11.3431 10.8431 10 12.5 10C14.1569 10 15.5 11.3431 15.5 13C15.5 14.6569 14.1569 16 12.5 16Z",
    fill: "black",
    fillOpacity: "0.65"
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.72243 5.33333L9.38397 3.5H15.616L17.2776 5.33333H19.8846C21.328 5.33333 22.5 6.49717 22.5 7.91667V18.9167C22.5 20.3362 21.328 21.5 19.8846 21.5H5.11538C3.67197 21.5 2.5 20.3362 2.5 18.9167V7.91667C2.5 6.49717 3.67197 5.33333 5.11538 5.33333H7.72243ZM8.38737 6.83333L10.0489 5H14.9511L16.6126 6.83333H19.8846C20.5147 6.83333 21 7.34064 21 7.91667V18.9167C21 19.4927 20.5147 20 19.8846 20H5.11538C4.48527 20 4 19.4927 4 18.9167V7.91667C4 7.34064 4.48527 6.83333 5.11538 6.83333H8.38737Z",
    fill: "black",
    fillOpacity: "0.65"
  }));
};
export default SVGComponent;